// extracted by mini-css-extract-plugin
export var ad = "footer-module--ad--WH8tS";
export var eason = "EasonPro, \"Times New Roman\", serif";
export var follow = "footer-module--follow--TZyre";
export var footer = "footer-module--footer--RNPUO index-module--fullWidth--jvj2O util-module--fullWidth--iiqEb";
export var header = "footer-module--header--ahyiL";
export var logo = "footer-module--logo--6BxKt";
export var mqMaxLg = "screen and (max-width: 67.625em)";
export var mqMaxMd = "screen and (max-width: 48em)";
export var mqMinMd = "screen and (min-width: 48em)";
export var nav = "footer-module--nav--0-zsZ";
export var navAd = "footer-module--navAd--SKn8q";
export var social = "footer-module--social--LU87p";